import script from "./PredefinedQueriesContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PredefinedQueriesContainer.vue?vue&type=script&lang=ts&setup=true"

import "./PredefinedQueriesContainer.vue?vue&type=style&index=0&id=b15bf52a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b15bf52a"]])

export default __exports__